import { render, staticRenderFns } from "./UploadItemForUpload.vue?vue&type=template&id=089bd9e5&scoped=true&"
import script from "./UploadItemForUpload.vue?vue&type=script&lang=js&"
export * from "./UploadItemForUpload.vue?vue&type=script&lang=js&"
import style0 from "./UploadItemForUpload.vue?vue&type=style&index=0&id=089bd9e5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bd9e5",
  null
  
)

export default component.exports